import React from 'react';
import { appDocumentTitle } from '../appMeta';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { PageShell } from '../layout/PageShell';
import { MarketingRingkasanTabScreen } from './MarketingPage/TabScreens/Ringkasan';

export function DashboardPage() {
  useDocumentTitle(appDocumentTitle('Dashboard'));

  return (
    <PageShell title="Dashboard" testId="dashboard-root">
      <MarketingRingkasanTabScreen />
    </PageShell>
  );
}
